import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../header/Header";
import Sidebarr from "../sidebar/Sidebar";
import VendorSidebar from "../sidebar/VendorSidebar";
import Tool from "../sidebar/Tool";
import Footer from "../footer/Footer";
import axios from "../helper/axios";
import { useSelector } from "react-redux";

const getErrorDetail = (error, file) => {
  const parts = [];
  if (file) {
    const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
    parts.push(`Skedari: ${file.name} (${sizeMB} MB, ${file.type || "i panjohur"})`);
  }
  if (error?.response) {
    parts.push(`HTTP ${error.response.status}`);
    parts.push(JSON.stringify(error.response.data, null, 2));
  } else {
    parts.push(error?.message || "Network Error");
    if (file?.size > 1024 * 1024) {
      parts.push("Shënim: foto e madhe mund të jetë bllokuar nga serveri (nginx limit).");
    }
  }
  return parts.join("\n\n");
};

export default function BrandBanners() {
  const auth = useSelector((state) => state.auth);
  const { slug: routeSlug } = useParams();
  const brandSlug = String(routeSlug || "").trim().toLowerCase();

  const [brandInfo, setBrandInfo] = useState(null);
  const [brandBanners, setBrandBanners] = useState([]);
  const [loading, setLoading] = useState(false);

  const [newFile, setNewFile] = useState(null);
  const [newPreview, setNewPreview] = useState("");
  const [newSort, setNewSort] = useState("");

  const [editValues, setEditValues] = useState({});

  const loadBrandInfo = async () => {
    try {
      const res = await axios.get("/getBrands");
      const list = Array.isArray(res.data) ? res.data : [];
      const found = list.find(
        (b) => String(b.slug || "").trim().toLowerCase() === brandSlug
      );
      setBrandInfo(found || null);
    } catch (error) {
      console.error("Error loading brand info:", error);
      setBrandInfo(null);
    }
  };

  const apiData = async () => {
    if (!brandSlug) return;
    setLoading(true);
    try {
      const res = await axios.get("/getbrandbanners", {
        params: { slug: brandSlug }
      });
      if (res.status === 200 && Array.isArray(res.data)) {
        setBrandBanners(res.data);

        const values = {};
        res.data.forEach((b) => {
          values[b._id] = {
            sort: b.sort != null ? b.sort : "",
            file: null
          };
        });
        setEditValues(values);
      } else {
        setBrandBanners([]);
      }
    } catch (error) {
      console.error("Error loading brand banners:", error);
      setBrandBanners([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadBrandInfo();
    apiData();
  }, [brandSlug]);

  const onSelectNewFile = (e) => {
    const file = e.target.files && e.target.files[0];
    setNewFile(file || null);
    setNewPreview(file ? URL.createObjectURL(file) : "");
  };

  const addBrandBanner = async () => {
    if (!newFile) {
      alert("Ju lutem zgjidhni një foto!");
      return;
    }

    const formData = new FormData();
    formData.append("brandBannerImage", newFile);
    formData.append("slug", brandSlug);
    formData.append("sort", newSort);

    try {
      const res = await axios.post("/addbrandbanner", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      if (res.status === 200) {
        alert("Banner u shtua me sukses!");
        setNewFile(null);
        setNewPreview("");
        setNewSort("");
        const input = document.getElementById("newBrandBannerFile");
        if (input) input.value = "";
        apiData();
      }
    } catch (error) {
      console.error("Error adding brand banner:", error);
      alert(getErrorDetail(error, newFile));
    }
  };

  const setRowValue = (id, field, value) => {
    setEditValues((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value }
    }));
  };

  const updateBrandBanner = async (id) => {
    const values = editValues[id];
    if (!values) return;

    const formData = new FormData();
    formData.append("brandBannerId", id);
    formData.append("sort", values.sort);
    if (values.file) {
      formData.append("brandBannerImage", values.file);
    }

    try {
      const res = await axios.post("/updatebrandbanner", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      if (res.status === 200) {
        alert("Banner u përditësua me sukses!");
        apiData();
      }
    } catch (error) {
      console.error("Error updating brand banner:", error);
      alert(getErrorDetail(error, values.file));
    }
  };

  const deleteBrandBanner = async (id) => {
    if (!id) return;
    if (window.confirm("A jeni të sigurt që dëshironi të fshini këtë banner? Foto do të fshihet gjithashtu.")) {
      try {
        const res = await axios.post("/deletebrandbanner", { brandBannerId: id });
        if (res.status === 200) {
          alert("Banner u fshi me sukses!");
          apiData();
        }
      } catch (error) {
        console.error("Error deleting brand banner:", error);
        alert(getErrorDetail(error, null));
      }
    }
  };

  const brandTitle = brandInfo?.brand || brandSlug;

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        {auth?.user?.role === "Vendor" ? <VendorSidebar /> : <Sidebarr />}

        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Banerat — {brandTitle}
              <small>menaxho fotot dhe renditjen (sort)</small>
            </h1>
            <ol className="breadcrumb">
              <li>
                <a href="#">
                  <i className="fa fa-dashboard" /> Home
                </a>
              </li>
              <li>
                <Link to="/brandbanners">Brand Banners</Link>
              </li>
              <li className="active">{brandTitle}</li>
            </ol>
          </section>

          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Shto banner të ri</h3>
                <div className="box-tools pull-right">
                  <Link to="/brandbanners" className="btn btn-default btn-sm">
                    <i className="fa fa-arrow-left" /> Kthehu te brandet
                  </Link>
                </div>
              </div>
              <div className="box-body">
                <div className="row">
                  <div className="col-xs-6">
                    <label>Foto:</label>
                    <input
                      id="newBrandBannerFile"
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={onSelectNewFile}
                    />
                    {newPreview && (
                      <img
                        src={newPreview}
                        alt="preview"
                        style={{ marginTop: "8px", height: "80px", objectFit: "cover" }}
                      />
                    )}
                  </div>
                  <div className="col-xs-3">
                    <label>Sort (1, 2, 3...):</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="auto"
                      value={newSort}
                      onChange={(e) => setNewSort(e.target.value)}
                    />
                    <small className="text-muted">1 = i pari, 2 = i dyti</small>
                  </div>
                </div>
                <br />
                <button className="btn btn-primary" onClick={addBrandBanner}>
                  <i className="fa fa-plus" /> Shto Banner
                </button>
              </div>
            </div>

            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">
                  Banerat e {brandTitle} ({brandBanners.length})
                </h3>
              </div>
              <div className="box-body">
                {loading && <p>Duke ngarkuar...</p>}
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th style={{ width: "40px" }}>#</th>
                      <th style={{ width: "110px" }}>Foto</th>
                      <th style={{ width: "90px" }}>Sort</th>
                      <th style={{ width: "200px" }}>Ndrysho Foton</th>
                      <th style={{ width: "130px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {brandBanners.map((b, idx) => (
                      <tr key={b._id}>
                        <td>{idx + 1}</td>
                        <td>
                          <a href={b.image} target="_blank" rel="noopener noreferrer">
                            <img
                              src={b.image}
                              alt={`Banner ${idx + 1}`}
                              height="60"
                              width="60"
                              style={{ objectFit: "cover", borderRadius: "4px" }}
                            />
                          </a>
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            value={editValues[b._id]?.sort ?? ""}
                            onChange={(e) => setRowValue(b._id, "sort", e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => setRowValue(b._id, "file", e.target.files?.[0] || null)}
                          />
                          {editValues[b._id]?.file && (
                            <small className="text-green">Foto e re e zgjedhur</small>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-info"
                            style={{ marginRight: "5px" }}
                            onClick={() => updateBrandBanner(b._id)}
                            title="Ruaj ndryshimet"
                          >
                            <i className="fa fa-refresh" />
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => deleteBrandBanner(b._id)}
                            title="Fshi bannerin"
                          >
                            <i className="fa fa-trash" />
                          </button>
                        </td>
                      </tr>
                    ))}
                    {!loading && brandBanners.length === 0 && (
                      <tr>
                        <td colSpan="5" className="text-center">
                          Nuk ka banera për këtë brand. Shtoni të parin më lart.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>

        <Footer />
        <Tool />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  );
}
